import {internalApi} from "../../common/axios";
import {useQueryBase} from "../../shared/hooks/useHookBase";

const fetchMergeBlockMainData = async () => {
    const {data} = await internalApi.get('player/mergeMain');
    return data.rows;
}

export const useMergeBlockMainData = () => {
    return useQueryBase('mergeBlockMainData', fetchMergeBlockMainData);
}

const fetchMergeEventBlockMainData = async () => {
    const {data} = await internalApi.get('tableData/mergeEventBlockMainData');
    return data.rows;
}

export const useMergeEventBlockMainData = () => {
    return useQueryBase('mergeEventBlockMainData', fetchMergeEventBlockMainData);
}

const fetchColorTargetData = async () => {
    const {data} = await internalApi.get('tableData/colorTargetData');
    return {set: data.set, emblem: data.emblem, enemy: data.enemy};
}

export const useColorTargetData = () => {
    return useQueryBase('colorTargetData', fetchColorTargetData);
}

const fetchPassMasterData = async () => {
    const {data} = await internalApi.get('tableData/passMasterData');
    return Object.values(data.rows);
}

export const usePassMasterData = () => {
    return useQueryBase('passMasterData', fetchPassMasterData);
}

const fetchBadgeMasterData = async () => {
    const {data} = await internalApi.get('tableData/badgeMasterData');
    return Object.values(data.rows);
}

export const useBadgeMasterData = () => {
    return useQueryBase('badgeMasterData', fetchBadgeMasterData);
}

const fetchMergeEventMasterData = async () => {
    const {data} = await internalApi.get('tableData/mergeEventMasterData');
    return Object.values(data.rows);
}

export const useMergeEventMasterTableData = () => {
    return useQueryBase('mergeEventMasterTableData', fetchMergeEventMasterData);
}

const fetchSeasonThemeMasterData = async () => {
    const {data} = await internalApi.get('tableData/seasonThemeMasterData');
    return Object.values(data.rows);
}

export const useSeasonThemeTableData = () => {
    return useQueryBase('seasonThemeTableData', fetchSeasonThemeMasterData);
}

const fetchMiniGameData = async () => {
    const {data} = await internalApi.get('tableData/miniGameData');
    const {message, success, ...tables} = data;
    return tables;
}

export const useMiniGameData = () => {
    return useQueryBase('miniGameData', fetchMiniGameData);
}

const fetchSeasonMissionData = async () => {
    const {data} = await internalApi.get('tableData/seasonMissionData');
    return Object.values(data.rows);
}

export const useSeasonMissionData = () => {
    return useQueryBase('seasonMissionData', fetchSeasonMissionData);
}

const fetchOpenPopupData = async () => {
    const {data} = await internalApi.get('tableData/openPopupData');
    return Object.values(data.rows);
}

export const useOpenPopupData = () => {
    return useQueryBase('openPopupData', fetchOpenPopupData);
}

const fetchMergeEventData = async () => {
    const {data} = await internalApi.get('tableData/mergeEventData');
    return data.rows;
}

export const useMergeEventData = () => {
    return useQueryBase('mergeEventData', fetchMergeEventData);
}

const fetchProfileData = async () => {
    const {data} = await internalApi.get('tableData/profileData');
    return {profileImg: data.profileImg, profileFrame: data.profileFrame};
}

export const useProfileData = () => {
    return useQueryBase('profileData', fetchProfileData);
}
